const space = {
  0: 0,
  px: 1,
  0.5: 2,
  1: 4,
  1.5: 6,
  2: 8,
  2.5: 12,
  3: 16,
  3.5: 24,
  4: 32,
  4.5: 48,
  5: 64,
  5.5: 96,
  6: 128,
  6.5: 192,
  7: 256,
  7.5: 384,
  8: 512,

  gutter: 16,
  '-gutter': -16,
  columnGap: 16,
  '-columnGap': -16,
};

export default space;
